import React from 'react';
import PropTypes from 'prop-types';
import AddButton from '../AddButton';
import { map } from 'lodash';
import { FormSectionHeader } from '../form';

const renderFormSection = ({ fieldArray, props }) => {
  const {
    component: Component,
    onAddSection,
    setFieldValue,
    title,
    values,
    ...rest
  } = props;
  const buttonText = `Add ${title}`;
  return (
    <React.Fragment>
      {map(values[fieldArray.name], (item, index) => (
        <div key={item.id || item.tempId}>
          {index >= 0 && (
            <FormSectionHeader
              onRemove={() => fieldArray.remove(index)}
              title={`${title}`}
            />
          )}
          <Component
            {...rest}
            paths={[fieldArray.name, index]}
            setFieldValue={setFieldValue}
            values={values}
          />
        </div>
      ))}
      <AddButton onClick={() => fieldArray.push(onAddSection())}>
        {buttonText}
      </AddButton>
    </React.Fragment>
  );
};

renderFormSection.propTypes = {
  component: PropTypes.func.isRequired,
  fieldArray: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
  onAddSection: PropTypes.func.isRequired,
  props: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  onSearch: PropTypes.func,
};

export default renderFormSection;



// WEBPACK FOOTER //
// ./src/modules/common/layouts/renderFormSection.js